import { useState } from 'react';
import PageContentToggle from '../../../components/Menus/PageContentToggle';
import TopPortfolio from './TopPortfolio';
import TopManager from './TopManager';
import FlexWrapper from '../../FlexWrapper';
import AnalyticsExportButton from './AnalyticsExportButton';


const MostViewedAndDownloaded = ({ timeFrame, customeDate }) => {
    const [selectedTab, setSelectedTab] = useState('Portfolios')
    const [exportProps, setExportProps] = useState(null)

    const labels = [
        { label: 'Portfolios', active: selectedTab === 'Portfolios', onClick: () => setSelectedTab('Portfolios') },
        { label: 'Managers', active: selectedTab === 'Managers', onClick: () => setSelectedTab('Managers') }
    ]
    return (
        <>
            <FlexWrapper fullWidth justify="space-between" align="center" style={{ marginBottom: "0.75rem" }}>
                <PageContentToggle labels={labels} />
                {exportProps && <AnalyticsExportButton {...exportProps} />}
            </FlexWrapper>
            {selectedTab === 'Portfolios' && <TopPortfolio timeFrame={timeFrame} customeDate={customeDate} onExport={setExportProps}/>}
            {selectedTab === 'Managers' && <TopManager timeFrame={timeFrame} customeDate={customeDate} onExport={setExportProps}/>}
        </>
    )
}

export default MostViewedAndDownloaded;